import Vue from 'vue'
import VueRouter from 'vue-router'
import { isPreOrderActive } from '../campaign/Campaign.service'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Home.vue')
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () =>
      import(/* webpackChunkName: "Logout" */ '../views/authentication/logout/Logout.vue')
  },
  {
    path: '/my-orders',
    name: 'MyOrders',
    component: () =>
      import(/* webpackChunkName: "History" */ '../views/myOrders/MyOrders.vue')
  },
  {
    path: '/my-orders/:receipt',
    name: 'OrderReceipt',
    component: () =>
      import(/* webpackChunkName: "OrderReceipt" */ '../views/orderReceipt/OrderReceipt.vue')
  },
  {
    path: '/mobile-login',
    name: 'Login',
    component: () =>
      import(
        /* webpackChunkName: "Verification" */ '../views/authentication/login/Login.vue'
      )
    // beforeEnter: (to, from, next) => {
    //   if (store.state.isLoggedIn && !store.state.isPayLahTile) next({ path: '/' })
    //   else next()
    // }
  },
  {
    path: '/collect-free-masks',
    name: 'CollectFreeMasks',
    component: () =>
      import(
        /* webpackChunkName: "CollectFreeMasks" */ '../views/collectFreeMasks/CollectFreeMasks.vue'
      )
  },
  {
    path: '/locate-vending-machines',
    name: 'LocateVendingMachines',
    component: () =>
      import(
        /* webpackChunkName: "LocateVendingMachines" */ '../views/locateVendingMachines/LocateVendingMachines.vue'
      )
  },
  {
    path: '/locate-vending-machines/:filterProps',
    // name: 'LocateVendingMachines',
    component: () =>
      import(
        /* webpackChunkName: "LocateVendingMachines" */ '../views/locateVendingMachines/LocateVendingMachines.vue'
      ),
    props: true
  },
  {
    path: '/pre-order-additional-masks',
    name: 'Purchase',
    component: () =>
      import(/* webpackChunkName: "Purchase" */ '../views/purchase/Purchase.vue')
  },
  {
    path: '/checkout',
    name: 'Checkout',
    component: () =>
      import(/* webpackChunkName: "Checkout" */ '../views/Checkout.vue')
  },
  {
    path: '/successful-checkout',
    name: 'SuccessfulCheckout',
    component: () =>
      import(
        /* webpackChunkName: "SuccessfulCheckout" */ '../views/successfulCheckout/SuccessfulCheckout.vue'
      )
  },
  {
    path: '/qr/:uuid',
    name: 'DeepLinkReceipt',
    component: () => import(
      /* webpackChunkName: "DeepLinkReceipt" */ '../views/deeplinkReceipt/DeepLinkReceipt.vue'
    ),
    props: true
  },
  {
    path: '/under-maintenance',
    name: 'Maintenance',
    component: () =>
      import(/* webpackChunkName: "Maintenance" */ '../views/maintenance/Maintenance.vue')
  },
  {
    path: '/prelaunch',
    name: 'Prelaunch',
    component: () =>
      import(/* webpackChunkName: "Maintenance" */ '../views/maintenance/Maintenance.vue')
  },
  {
    path: '/not-found',
    name: 'NotFound',
    component: () =>
      import(/* webpackChunkName: "NotFound" */ '../views/NotFound.vue')
  },
  { path: '*', redirect: '/not-found' }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes
})

const orderRoutes = [
  'Purchase',
  'Checkout',
  'SuccessfulCheckout'
]

const guardOrderRoutes = (to, from, next) => {
  if (!isPreOrderActive() && orderRoutes.includes(to.name)) {
    next('/')
  } else {
    next()
  }
}

router.beforeEach(guardOrderRoutes)

export default router
